import MinhaConta from './components/MinhaConta'
import Inicial from './components/minha-conta/Inicial'
import EditarMeusDados from './components/minha-conta/EditarMeusDados'
import Notificacoes from './components/minha-conta/Notificacoes'
import MinhasNotificacoes from './components/MinhasNotificacoes'
import AtualizacaoDados from './components/AtualizacaoDados'
import Protocolo from './components/Protocolo'

export default [
  {
    path: '/minha-conta',
    component: MinhaConta,
    name: 'minha-conta',
    meta: {
      breadcrumb: {
        name: 'Minha Conta',
        to: 'minha-conta.inicial'
      }
    },
    children: [
      {
        path: '',
        component: Inicial,
        name: 'minha-conta.inicial',
        meta: {
          breadcrumb: {
            name: 'Perfil'
          }
        }
      },
      {
        path: 'dados-cadastrais',
        component: EditarMeusDados,
        name: 'minha-conta.dados-cadastrais',
        meta: {
          breadcrumb: {
            name: 'Dados Cadastrais'
          }
        }
      },
      {
        path: 'notificacoes',
        component: Notificacoes,
        name: 'minha-conta.notificacoes',
        meta: {
          breadcrumb: {
            name: 'Notificações'
          }
        }
      }
    ]
  },
  {
    path: '/notificacoes',
    component: MinhasNotificacoes,
    name: 'notificacoes',
    meta: {
      breadcrumb: {
        name: 'Minhas Notificações'
      }
    }
  },
  {
    path: '/atualizacao-dados/:hash?',
    component: AtualizacaoDados,
    name: 'atualizacao-dados',
    meta: {
      breadcrumb: {
        name: 'Atualização de Dados Cadastrais'
      },
      auth: false
    }
  },
  {
    path: '/protocolo',
    component: Protocolo,
    name: 'protocolo',
    meta: {
      breadcrumb: {
        name: 'Protocolo'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/domains/pessoal/routes.js